import {FC} from 'react';

import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

import {IHeadCellContactPerson} from '../../../../../../../shared/types/table.types';

interface ITableHeadContactPerson {
  headCells: IHeadCellContactPerson[];
  collapse?: boolean;
  actionButtons?: boolean;
}

const TableHeadContactPerson: FC<ITableHeadContactPerson> = ({headCells, collapse, actionButtons}) => {
  return (
    <TableHead>
      <TableRow>
        {collapse && <TableCell />}
        {headCells.map((headCell) => (
          <TableCell key={headCell.id} align="left" padding={headCell.disablePadding ? 'none' : 'normal'}>
            {headCell.label}
          </TableCell>
        ))}
        {actionButtons && (
          <TableCell
            sx={{
              minWidth: 85,
            }}
          />
        )}
      </TableRow>
    </TableHead>
  );
};

export default TableHeadContactPerson;
